import { Checkbox, Col, Divider, Form, Row } from 'antd';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { StyledStack } from 'app/components/Stack';
import StyledButton from 'app/components/StyledButton';
import StyledCollapse, {
  CollapsePanelWrapper,
} from 'app/components/StyledCollapse';
import StyledTable from 'app/components/StyledTable';
import useGetApiData from 'app/hooks/useGetApiData';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import {
  selectIsLogged,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { I_CheckoutCartItem } from 'app/pages/Cart/slice/types';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import { TimeoutModal } from 'app/pages/Checkout/ConfirmPolicyOrder';
import {
  MATERRIAL_EVOUCHER_TYPE,
  useCheckout,
} from 'app/pages/Checkout/hooks/useCheckout';
import { Orderdate } from 'app/pages/Checkout/slice/types';
import { CheckoutWrapper } from 'app/pages/Checkout/styled';
import { CommonText } from 'app/pages/NewAccount/CheckTickets/styled';
import Countdown from 'app/pages/TicketRefund/components/Countdown';
import { cancelOrderApi } from 'app/services/authApi';
import * as _ from 'lodash';
import moment from 'moment';
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { notify } from 'reapop';
import styled from 'styled-components';
import { DEFAULT_LANGUAGE, TICKET_TYPES, TYPE_COOKIE } from 'utils/constants';
import { getCookie } from 'utils/cookies';
import {
  formatNumber,
  formatTimeFrame,
  renderReplaceText,
  windowOpenLink,
} from 'utils/helper';
import useCountDown from 'utils/hooks/useCountDown';
import { Layout } from '../../layouts';
import { ACCOUNT_MNG_MENU } from '../../layouts/AccountManager';
import { GET_LIST_PAYMENT_METHOD } from '../slice';
interface Props {}

const replacePaymentWithSpan = (
  text: string,
  replaceText: string,
  replaceTo: string,
  style: React.CSSProperties = {},
) => {
  const parts = text.split(replaceText);

  const newText = parts.map((part, index) => (
    <>
      {part}
      {index < parts.length - 1 && <span style={style}>{replaceTo}</span>}
    </>
  ));

  return <>{newText}</>;
};

export const ConfirmPayment = memo((props: Props) => {
  const [formInfoUser] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isAccept, setIsAccept] = useState(false);
  const [termTxt, setTermTxt] = useState('');
  const [isShowTimeout, setIsShowTimeout] = useState(false);
  const [isLoadingCancelOrder, setIsLoadingCancelOrder] =
    useState<boolean>(false);
  const [menu, setMenu] = useState<ACCOUNT_MNG_MENU>();
  const { isLoading: isLoadingCancel, handleRequest: handleRequestCancel } =
    useGetApiData({
      api: cancelOrderApi,
      isSkip: true,
    });
  const isLogged = useSelector(selectIsLogged);
  const translations = useSelector(selectTranslations);
  const {
    loading,
    INIT_FORM,
    setEnableConfirm,
    orderCheckout,
    idOrder,
    payment,
    onSubmitForm,
    bankInfo,
    orderState,
    expiredHours,
    isValidPaymentTime,
    expiredAt,
    startTime,
    order,
    vouchers,
    listCart,
  } = useCheckout();
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();

  const handleRidrect = () => {
    if (
      payment?.code &&
      payment?.code.toLowerCase() == 'banktransfer' &&
      orderState?.value === 'paymentPending'
    ) {
      if (orderState?.value === 'cancelled') {
        history.push({
          pathname: '/account',
          state: {
            orderState: 'cancelled',
            payment: payment?.code,
          },
        });
        return;
      }
      if (orderState?.value === 'success') {
        history.push({
          pathname: '/account',
          state: {
            orderState: 'success',
            payment: payment?.code,
          },
        });
        return;
      }
    }
    return windowOpenLink({
      url: '/account',
      target: '_self',
    });
  };
  const timeDistance = useMemo(() => {
    return (
      moment(expiredAt?.datetimeDMYHIS, 'HH:mm:ss DD/MM/YYYY').valueOf() -
      moment(startTime?.datetimeDMYHIS, 'HH:mm:ss DD/MM/YYYY').valueOf()
    );
  }, [expiredAt?.datetimeDMYHIS, startTime?.datetimeDMYHIS]);
  useEffect(() => {
    if (isLogged) formInfoUser.setFieldsValue({ ...INIT_FORM });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged, INIT_FORM]);
  useEffect(() => {
    dispatch(
      GET_LIST_PAYMENT_METHOD({
        ticketType: sessionStorage.getItem('ticketType'),
      }),
    );
    // if (!cartLength) history.push('/');
    // else dispatch(GET_LIST_PAYMENT_METHOD());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchTerm = async () => {
      const language =
        (await getCookie(TYPE_COOKIE.LANGUAGE)) || DEFAULT_LANGUAGE;
      fetch(`/policy-payment-${language}.txt`)
        .then(response => response.text())
        .then(data => {
          setTermTxt(data);
        });
    };
    fetchTerm();
  }, []);

  useEffect(() => {
    if (payment?.code && payment?.code.toLowerCase() == 'banktransfer') {
      if (orderState?.value === 'success') {
        history.push({
          pathname: '/account',
          state: {
            orderState: 'success',
            payment: payment?.code,
          },
        });
      }
      if (orderState?.value === 'cancelled') {
        history.push({
          pathname: '/account',
          state: {
            orderState: 'cancelled',
            payment: payment?.code,
          },
        });
      }
    }
  }, [payment, orderState]);

  useEffect(() => {
    // orderState: "cancelled", payment: "BankTransfer"
    const historyState: any = location?.state;
    setMenu(historyState?.menu);
  }, [location]);
  useEffect(() => {
    if (isShowTimeout) {
      onCloseDialogNoti();
      return;
    }
    if (order?.isFocAltered === 1 && !_.isEmpty(order?.alteredFocData)) {
      openFocConfirmDialog(order);
    }
  }, [order, isShowTimeout]);
  const openFocConfirmDialog = useCallback(
    currentOrder => {
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        maxWidth: 550,
        content: (
          <div style={{ maxHeight: 300, overflow: 'auto' }}>
            {currentOrder?.alteredFocData?.map((el, index) => {
              return (
                <div key={index}>
                  ○&nbsp;
                  {renderReplaceText(
                    translations?.['b2b.txt.focTicketReplaced'],
                    {
                      foc1: {
                        value: el?.original_foc?.product_name,
                        style: { fontWeight: 'bold' },
                      },
                      selected_date: moment(
                        el?.alternative_foc?.date,
                        'YYYYMMDD',
                      ).format('DD/MM/YYYY'),
                      foc2: {
                        value: el?.alternative_foc?.product_name,
                        style: { fontWeight: 'bold' },
                      },
                    },
                  )}
                </div>
              );
            })}
            <NoteFoc>{translations?.['b2b.txt.confirmContinueOrder']}</NoteFoc>
          </div>
        ),
        title: translations?.['b2b.txt.confirmFocTicket'],
        closable: false,
        buttons: [
          {
            text: translations?.['b2b.txt.cancel-order'] ?? '',
            bg: '#ffff',
            border: 'solid 1px #808080',
            color: '#808080',
            onClick: () => {
              onCancelOrder(currentOrder);
            },
          },
          {
            text: translations?.['b2b.btn.accept'] ?? '',
            bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
            color: 'white',
            onClick: () => {
              onCloseDialogNoti();
            },
          },
        ],
      });
    },
    [translations, onCloseDialogNoti, onOpenDialogNoti, isLoadingCancel],
  );
  const onCancelOrder = async orderParam => {
    try {
      onCloseDialogNoti();
      setIsLoadingCancelOrder(true);
      const formData = new FormData();
      formData.append('idHash', orderParam.idHash);
      const response = await cancelOrderApi(formData);
      if (response?.status === 200) {
        setIsLoadingCancelOrder(false);
        history.push('/account?route=tab-3');
      }
    } catch (err: any) {
      setIsLoadingCancelOrder(false);
      dispatch(
        notify(
          err?.message ?? translations?.['b2b.txt.cancelOrderFailed'] ?? '',
          'error',
          {
            title: 'Oops',
            dismissAfter: 5000,
          },
        ),
      );
    }
  };
  return (
    <Layout menuActive={menu} disableContainerStyle>
      <CheckoutWrapper>
        <LoadingContainer
          isFullPage
          loading={loading || isLoadingCancel || isLoadingCancelOrder}
        >
          {payment?.code && payment?.code.toLowerCase() !== 'banktransfer' && (
            <>
              <div className="checkOutInfo">
                <StyledStack justifyContent={'space-between'}>
                  <Title
                    style={{
                      fontSize: 20,
                      color: '#000',
                      fontWeight: 600,
                    }}
                  >
                    {translations?.['b2b.upgrade.title']}
                  </Title>
                  <StyledStack
                    display={{ lg: 'flex', xs: 'none' }}
                    style={{ width: 'fit-content' }}
                  >
                    {!_.isNil(timeDistance) && (
                      <CountDownWrapper
                        timeDistance={timeDistance}
                        idOrder={idOrder}
                        isShowView
                        startTime={startTime}
                      />
                    )}
                  </StyledStack>
                </StyledStack>
                <HeaderContainer
                  style={{
                    justifyContent: 'flex-start',
                  }}
                >
                  <CommonText
                    style={{
                      fontSize: 16,
                      color: '#000',
                      fontWeight: 600,
                    }}
                  >
                    {translations?.['b2b.txt.exchange-order-number']}
                  </CommonText>
                  <CommonText
                    style={{
                      fontSize: 16,
                      color: '#E92127',
                      fontWeight: 600,
                      marginLeft: 4,
                    }}
                  >
                    {idOrder}
                  </CommonText>
                </HeaderContainer>
                {expiredHours && isValidPaymentTime && (
                  <Description>
                    {translations
                      ? replacePaymentWithSpan(
                          translations['b2c.txt.pay-order-description'],
                          '${payment}',
                          payment?.name ?? '',
                          { fontWeight: 'bold' },
                        )
                      : ''}{' '}
                    {translations
                      ? replacePaymentWithSpan(
                          translations['b2c.txt.pay-order-description-1'],
                          '${hour}',
                          expiredHours + 'h',
                          { color: '#E92127' },
                        )
                      : ''}
                  </Description>
                )}
                <OrderInfoCollapse
                  order={order}
                  listCart={listCart}
                  vouchers={vouchers}
                />

                {isValidPaymentTime && (
                  <>
                    <StyledPolicy>
                      <Policy>
                        <SubHeaderContainer>
                          <div style={{ textTransform: 'capitalize' }}>
                            {translations
                              ? translations['b2c.txt.paymentPolicy']
                              : ''}
                          </div>
                        </SubHeaderContainer>
                        <Description
                          style={{ textAlign: 'justify', marginRight: 8 }}
                        >
                          {termTxt.split('\n').map((val, index) => (
                            <div key={index} style={{ whiteSpace: 'pre-wrap' }}>
                              {val}
                              <br />
                            </div>
                          ))}
                        </Description>
                      </Policy>
                    </StyledPolicy>
                    <Checkbox
                      style={{ margin: '12px 0px' }}
                      onChange={e => {
                        setIsAccept(!isAccept);
                      }}
                    >
                      {translations
                        ? translations['b2c.txt.accept-policy']
                        : ''}
                    </Checkbox>
                    <StyledDivider
                      style={{
                        margin: '20px 0px 25px 0px',
                      }}
                      dashed
                    />
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <StyledButton
                        bgColor="white"
                        border="1px solid #808080"
                        textColor="#808080"
                        height={'44px'}
                        onClick={() =>
                          windowOpenLink({
                            url: '/account',
                            target: '_self',
                          })
                        }
                        style={{
                          marginRight: 16,
                          width: 'max-content',
                        }}
                      >
                        {translations
                          ? translations['b2b.txt.back-to-history']
                          : ''}
                      </StyledButton>
                      <StyledButton
                        disabled={!isAccept}
                        border="none"
                        textColor="#ffffff"
                        onClick={() => {
                          setEnableConfirm(false);
                          setTimeout(() => onSubmitForm(), 100);
                        }}
                        height={'44px'}
                      >
                        <span style={{ marginRight: 8 }}>
                          {translations ? translations['b2c.txt.confirm'] : ''}
                        </span>
                        <i className="fa-solid fa-arrow-right"></i>
                      </StyledButton>
                    </div>
                  </>
                )}
                {!isValidPaymentTime && (
                  <div
                    className="--sub-title"
                    style={{ fontStyle: 'normal', textAlign: 'center' }}
                  >
                    {translations
                      ? `${translations[
                          'b2b.txt.note-transfer-money-invalid'
                        ]?.replace('${payment}', payment.name)}`
                      : ''}
                  </div>
                )}
              </div>
            </>
          )}
          {payment?.code && payment?.code.toLowerCase() === 'banktransfer' && (
            <>
              <div className="checkOutInfo">
                <StyledStack justifyContent={'flex-start'}>
                  <Title
                    style={{
                      fontSize: 20,
                      color: '#000',
                      fontWeight: 600,
                    }}
                  >
                    {translations?.['b2b.upgrade.title']}
                  </Title>
                </StyledStack>
                {!_.isNil(timeDistance) && (
                  <CountDownWrapper
                    timeDistance={timeDistance}
                    idOrder={idOrder}
                  />
                )}
                <HeaderContainer
                  style={{
                    justifyContent: 'flex-start',
                  }}
                >
                  <CommonText
                    style={{
                      fontSize: 16,
                      color: '#000',
                      fontWeight: 600,
                    }}
                  >
                    {translations?.['b2b.txt.exchange-order-number']}
                  </CommonText>
                  <CommonText
                    style={{
                      fontSize: 16,
                      color: '#E92127',
                      fontWeight: 600,
                      marginLeft: 4,
                    }}
                  >
                    {idOrder}
                  </CommonText>
                </HeaderContainer>
                <Description>
                  {expiredHours ? (
                    <>
                      {translations
                        ? replacePaymentWithSpan(
                            translations['b2c.txt.pay-order-description'],
                            '${payment}',
                            payment?.name ?? '',
                            { fontWeight: 'bold' },
                          )
                        : ''}{' '}
                      {translations
                        ? replacePaymentWithSpan(
                            translations['b2c.txt.pay-order-description-1'],
                            '${hour}',
                            expiredHours + 'h',
                            { color: '#E92127' },
                          )
                        : ''}
                    </>
                  ) : (
                    <>
                      {translations &&
                        replacePaymentWithSpan(
                          translations['b2c.txt.pay-order-description'],
                          '${payment}',
                          translations['b2b.txt.bank-transfer'],
                          {
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                          },
                        )}
                      {'. '}
                      {translations
                        ? translations['b2b.txt.pay-order-description-2']
                        : ''}
                    </>
                  )}
                </Description>
                <OrderInfoCollapse
                  order={order}
                  listCart={listCart}
                  vouchers={vouchers}
                />

                {(order?.totalPrice || 0) > 0 && (
                  <>
                    <Divider />
                    <HeaderContainer
                      style={{
                        justifyContent: 'flex-start',
                        marginTop: 16,
                      }}
                    >
                      <CommonText
                        style={{
                          fontSize: 16,
                          color: '#000',
                          fontWeight: 600,
                        }}
                      >
                        {translations
                          ? translations['b2b.txt.paymentGuide']
                          : ''}
                      </CommonText>
                    </HeaderContainer>
                    {isValidPaymentTime && (
                      <>
                        <Description>
                          {translations
                            ? replacePaymentWithSpan(
                                translations[
                                  'b2b.form-policy.bank_descriptions'
                                ],
                                '${totalPrice}',
                                `${
                                  formatNumber(order?.totalPrice).replaceAll(
                                    ',',
                                    '.',
                                  ) + 'đ'
                                }`,
                                { fontWeight: 'bold', color: '#E92127' },
                              )
                            : ''}
                        </Description>
                        <Row nz-row className="d-flex txt-content">
                          <Col xs={8} md={4}>
                            {translations
                              ? `${translations['b2b.txt.bank-account']}: `
                              : ''}
                          </Col>
                          <Col xs={14} md={18}>
                            {bankInfo?.bankAccount}
                          </Col>
                        </Row>
                        <Row nz-row className="d-flex txt-content">
                          <Col xs={8} md={4}>
                            {translations
                              ? `${translations['b2c.txt.bank']}: `
                              : ''}
                          </Col>
                          <Col xs={14} md={18}>
                            {bankInfo?.bankName}
                          </Col>
                        </Row>
                        <Row nz-row className="d-flex txt-content">
                          <Col xs={8} md={4}>
                            {translations
                              ? `${translations['b2c.txt.modal-ticket-content']}: `
                              : ''}
                          </Col>
                          <Col xs={14} md={18}>
                            {idOrder}
                          </Col>
                        </Row>
                      </>
                    )}
                    <div
                      className="--sub-title"
                      style={
                        isValidPaymentTime
                          ? { margin: '17px 0px' }
                          : { fontStyle: 'normal', textAlign: 'left' }
                      }
                    >
                      {translations
                        ? `${translations[
                            isValidPaymentTime
                              ? 'b2b.txt.note-transfer-money'
                              : 'b2b.txt.note-transfer-money-invalid'
                          ]?.replace('${payment}', payment?.name ?? '')}: `
                        : ''}
                    </div>
                    {isValidPaymentTime && (
                      <>
                        <div className="d-flex txt-content">
                          {translations ? translations['b2b.txt.QR-code'] : ''}
                        </div>
                        <ImgWrapper>
                          <div className="d-flex justify-content-center">
                            <StyledImg
                              src={bankInfo?.qrCode?.original}
                              alt=""
                            />
                          </div>
                        </ImgWrapper>
                      </>
                    )}
                    <StyledDivider
                      style={{
                        margin: '20px 0px 25px 0px',
                      }}
                      dashed
                    />
                  </>
                )}

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <StyledButton
                    bgColor="white"
                    border="1px solid #808080"
                    textColor="#808080"
                    height={'44px'}
                    onClick={() => handleRidrect()}
                    style={{
                      marginRight: 16,
                      width: 'auto',
                      minWidth: 160,
                    }}
                  >
                    {translations
                      ? translations['b2b.txt.back-to-history']
                      : ''}
                  </StyledButton>
                  {(order?.totalPrice || 0) <= 0 && (
                    <StyledButton
                      border="none"
                      textColor="#ffffff"
                      onClick={() => {
                        onSubmitForm();
                      }}
                      height={'44px'}
                    >
                      <span style={{ marginRight: 8 }}>
                        {translations ? translations['b2c.txt.confirm'] : ''}
                      </span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </StyledButton>
                  )}
                </div>
              </div>
            </>
          )}
        </LoadingContainer>
        <TimeoutModal
          open={isShowTimeout}
          onClose={() => {
            const fromData = new FormData();
            fromData.append('idHash', `${orderCheckout.current?.idHash}`);
            handleRequestCancel(fromData).then(() => {
              history.push(
                '/payment-callback?vnp_TxnRef=' + orderCheckout.current?.idHash,
              );
            });
          }}
        />
      </CheckoutWrapper>
    </Layout>
  );
});

const Policy = styled.div`
  background: #ffffff;
  overflow: auto;
  height: 600px;
  ::-webkit-scrollbar {
    width: 6px; /* Width of the scrollbar */
  }

  /* Define the track (the area behind the thumb) */
  ::-webkit-scrollbar-track {
    background: transparent; /* Color of the track */
  }

  /* Define the scrollbar thumb */
  ::-webkit-scrollbar-thumb {
    background: #ececec; /* Color of the thumb */
    border-radius: 20px;
  }

  /* Define the scrollbar thumb on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #d6d6d6; /* Color of the thumb on hover */
  }
`;

const StyledPolicy = styled.div`
  border-radius: 20px;
  background: #ffffff;
  /* height: 301px; */
  padding: 24px 20px;
  border: 1px solid #d9d9d9;
  color: #000000;
  margin-top: 12px;
`;

const Title = styled.h4`
  margin: 0;
  font-weight: 600;
  color: #000000;
  font-size: 24px;
  text-transform: capitalize;
`;

const Description = styled.p`
  font-weight: 400;
  color: #000000;
  font-size: 14px;
  text-align: left;
  margin-top: 14px;
  line-height: 1.7rem;
`;

const HeaderContainer = styled.div`
  margin: 10px 0px;
  display: flex;
  justify-content: center;
  color: #000000;
`;
const SubHeaderContainer = styled.div`
  margin: 10px 0px;
  display: flex;
  color: #000000;
  font-size: 16px;
  font-weight: 600;
`;

const StyledDivider = styled(Divider)`
  margin: 14px 0px 14px 0px;
  width: 100%;
  min-width: 100%;
`;
const ImgWrapper = styled.div`
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
`;
const StyledImg = styled.img`
  width: 250px;
  max-width: 100%;
  height: 'auto';
  display: 'flex';
  justify-content: 'center';
  object-fit: cover;
  &[src=''] {
    opacity: 0;
  }
`;

const VoucherAccount = styled.div`
  .card .--price-discount,
  .total-price {
    color: #e92127;
    font-weight: 600;
    font-size: 16px;
  }
  .card {
    height: 68px;
    border-radius: 5px;
    background-color: #fff8f8;
    padding: 10px 10px;
    position: relative;
    border: 1px solid #fdd7d7;
    padding: 14px 24px;
    display: flex;
    justify-content: center;
    .title-voucher {
      font-size: 14px;
      font-weight: 500;
      color: #132639;
      margin-right: 12px;
    }
  }

  .card::after {
    position: absolute;
    content: '';
    height: 16px;
    right: -8px;
    border-radius: 8px;
    z-index: 1;
    top: 26px;
    background-color: #ffffff;
    width: 16px;
    border-left: 1px solid #fdd7d7;
  }

  .card::before {
    position: absolute;
    content: '';
    height: 16px;
    left: -8px;
    border-radius: 8px;
    z-index: 1;
    top: 26px;
    background-color: #ffffff;
    width: 16px;
    border-right: 1px solid #fdd7d7;
  }
`;
const NoteFoc = styled.div`
  margin-top: 12px;
  text-align: center;
`;

const CountDownWrapper = ({
  timeDistance,
  idOrder,
  isShowView,
  startTime,
}: {
  timeDistance: number;
  idOrder?: number;
  isShowView?: boolean;
  startTime?: Orderdate;
}) => {
  const translations = useSelector(selectTranslations);
  const history = useHistory();
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const startTimeOrigin = moment(
    startTime?.datetimeDMYHIS ?? undefined,
    'HH:mm:ss DD/MM/YYYY',
  );
  const { timeRemaining } = useCountDown({
    time: timeDistance,
    startTime: startTimeOrigin.valueOf(),
    onTimeout: () => {
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: '',
        // content:
        //   translations?.['b2b.txt.refundOrderExpried']?.replace(
        //     '{orderNumber}',
        //     idOrder,
        //   ) ?? '',
        content: (
          <div style={{ textAlign: 'center', fontWeight: 500, fontSize: 14 }}>
            <span style={{ display: 'block' }}>
              {translations ? translations['b2b.txt.timeoutPayment'] : ''}
            </span>
            <span style={{ display: 'block' }}>
              {translations ? translations['b2b.txt.retry'] : ''}
            </span>
          </div>
        ),
        closable: true,
        maskClosable: false,
        onCloseDialog: () => {
          onCloseDialogNoti();
          history.push('/account', {
            targetTab: 'tab-3',
          });
        },
      });
    },
  });
  return (
    <>
      {!_.isNil(timeRemaining) && isShowView ? (
        <Countdown time={timeRemaining} />
      ) : undefined}
    </>
  );
};

const OrderInfoCollapse = ({
  order,
  vouchers,
  listCart,
}: {
  order: any;
  vouchers: Partial<I_CheckoutCartItem>[];
  listCart: I_CheckoutCartItem[];
}) => {
  const translations = useSelector(selectTranslations);
  const listGift = useMemo(() => {
    return listCart
      ?.filter(item => item?.isGift)
      ?.filter(item => item.materialType !== MATERRIAL_EVOUCHER_TYPE);
  }, [listCart]);
  const dataSourceFormatted = useCallback(
    listTicket => {
      const total = listTicket?.reduce(
        (obj, ticket) => {
          obj.originalPrice += Number(ticket?.originalPrice || 0);
          obj.amount += Number(ticket?.amount || 0);
          obj.exchangeCharge += Number(ticket?.exchangeCharge || 0);
          return obj;
        },
        {
          originalPrice: 0,
          amount: 0,
          exchangeCharge: 0,
          name: translations?.['b2b.upgrade.total'],
          product: { name: translations?.['b2b.upgrade.total'] },
        },
      );
      return [...(listTicket || []), total];
    },
    [translations],
  );
  const column = [
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.ticket-name']}
        </div>
      ),
      dataIndex: 'product',
      key: 'product',
      render: value => <div style={{ textAlign: 'left' }}>{value?.name}</div>,
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.park']}
        </div>
      ),
      dataIndex: 'park',
      key: 'park',
      render: value => <div style={{ textAlign: 'left' }}>{value?.name}</div>,
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.ticket-type']}
        </div>
      ),
      dataIndex: 'catalog',
      key: 'catalog',
      render: value => <div style={{ textAlign: 'left' }}>{value?.name}</div>,
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.expired-time']}
        </div>
      ),
      dataIndex: 'date',
      key: 'date',
      render: value =>
        value?.date && (
          <div style={{ textAlign: 'left' }}>
            {moment(value?.date, 'YYYY/MM/DD').format('DD/MM/YYYY')}
          </div>
        ),
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.ticket-detail']}
        </div>
      ),
      key: 'detail',
      render: value => {
        const isCableTicket = value?.materialType === TICKET_TYPES.CABLE_CAR;
        const zone = value?.zone?.name;
        const restaurant = value?.restaurant?.name;
        const performance = formatTimeFrame(
          value?.product?.usedArea2Object?.label,
        );

        if (isCableTicket) return <div />;

        return (
          <div style={{ textAlign: 'left' }}>
            {zone && <div>{zone}</div>}
            {restaurant && <div>{restaurant}</div>}
            {performance && <div>{performance}</div>}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.ticket-amount']}
        </div>
      ),
      dataIndex: 'amount',
      key: 'amount',
      render: value => <div style={{ textAlign: 'left' }}>{value}</div>,
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.bill']}
        </div>
      ),
      key: 'originalPrice',
      render: value => (
        <div
          style={{ textAlign: 'left', display: !value?.id ? 'none' : 'flex' }}
        >
          {`${formatNumber(value?.originalPrice).replaceAll(',', '.')}đ`}
        </div>
      ),
    },

    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.total-bill']}
        </div>
      ),
      key: 'price',
      render: value => {
        if (value?.totalNewTicket) {
          return (
            <div
              style={{
                textAlign: 'left',
                color: '#E92127',
              }}
            >
              {`${formatNumber(value?.totalNewTicket).replaceAll(',', '.')}đ`}
            </div>
          );
        }
        return (
          <div
            style={{
              textAlign: 'left',
              color: !value?.id ? '#E92127' : 'black',
            }}
          >
            {`${formatNumber(value?.originalPrice * value?.amount).replaceAll(
              ',',
              '.',
            )}đ`}
          </div>
        );
      },
    },
  ];

  return (
    <StyledCollapse defaultActiveKey={['1', '2', '3']}>
      <CollapsePanelWrapper
        key="1"
        header={translations?.['b2b.upgrade.list-exchange-order']}
      >
        <StyledTable
          dataSource={dataSourceFormatted(order?.items)}
          columns={column}
          styleSlots={{
            footerCSS: {
              backgroundColor: '#f5f5f5',
              fontWeight: 'bold',
            },
          }}
          pagination={false}
        />
      </CollapsePanelWrapper>
      {!!vouchers?.length ||
        (!!listGift?.length && (
          <CollapsePanelWrapper
            key="2"
            header={translations?.['b2b.txt.voucher-info']}
          >
            <StyledStack direction={'column'} rowGap={'16px'}>
              <StyledStack
                columnGap={'20px'}
                rowGap={'16px'}
                style={{ flexWrap: 'wrap' }}
              >
                {!!vouchers?.length &&
                  vouchers.map((voucher, idx) => (
                    <VoucherAccount>
                      <div key={`${idx}`} className="card">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="title-voucher">
                            {voucher.product?.name ?? ''}
                          </div>
                          {/* <div className="--price-discount">-100.000đ</div> */}
                        </div>
                      </div>
                    </VoucherAccount>
                  ))}
                {!!listGift?.length &&
                  listGift.map((gift, idx) => (
                    <VoucherAccount>
                      <div key={`${idx}`} className="card">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="title-voucher">
                            <TooltipParagraph
                              ellipsis={{ rows: 1 }}
                              style={{
                                marginBottom: 0,
                                textAlign: 'left',
                              }}
                            >
                              {gift.product?.name ?? ''}
                            </TooltipParagraph>
                            <div style={{ fontSize: 12 }}>{`${
                              translations?.['b2b.table.quantity']
                            }: ${gift.amount ?? ''}`}</div>
                          </div>
                          <div className="total-price">
                            {formatNumber(gift?.originalPrice ?? 0)}đ
                          </div>
                        </div>
                      </div>
                    </VoucherAccount>
                  ))}
              </StyledStack>
            </StyledStack>
          </CollapsePanelWrapper>
        ))}
      <CollapsePanelWrapper
        key="3"
        header={translations?.['b2b.upgrade.pay-exchange-order']}
      >
        <StyledStack direction={'column'} rowGap={'16px'}>
          <StyledStack columnGap={'20px'} justifyContent={'space-between'}>
            <CommonText>{translations?.['b2b.upgrade.total-diff']}</CommonText>
            <CommonText style={{ color: '#E92227' }}>
              {formatNumber(
                (order?.differenceAmount || 0) + (order?.totalDiscount || 0),
              ).replaceAll(',', '.') + 'đ'}
            </CommonText>
          </StyledStack>
          <StyledStack columnGap={'20px'} justifyContent={'space-between'}>
            <CommonText>{translations?.['b2c.txt.discount']}</CommonText>
            <CommonText style={{ color: '#F8B117' }}>
              -{formatNumber(order?.totalDiscount).replaceAll(',', '.') + 'đ'}
            </CommonText>
          </StyledStack>
          <StyledStack columnGap={'20px'} justifyContent={'space-between'}>
            <CommonText style={{ fontSize: 16 }}>
              {translations?.['b2b.txt.pay-more']}
            </CommonText>
            <CommonText style={{ fontSize: 16, color: '#E92227' }}>
              {formatNumber(order?.totalPrice).replaceAll(',', '.') + 'đ'}
            </CommonText>
          </StyledStack>
        </StyledStack>
      </CollapsePanelWrapper>
    </StyledCollapse>
  );
};
